import Vue from 'vue'
import Router from 'vue-router'
import mediator from './mediator'
import judges from './judges'
import disputeMediation from './disputeMediation'
import onlineMediation from './onlineMediation'
import useraction from './useraction'
import organcenter from './organcenter'
import admin from './admin'
import userCenter from './userCenter'
import greffier from './greffier'
import counselor from './consultant'
import customer from './customerService'
import lawsuit from './lawsuit'
import infocenter from './infocenter'
import judicial from './judicial'
import trainingMaterial from './trainingMaterial'
import tempMediation from './tempMediation'
import select from './select'
import statAnalysis from './statAnalysis'
import backstage from './backstage'
import test from './test'
import auth from './auth'
import applets from './applets'
import operationlog from './operationlog'
import { getHnswToken } from '@/publicResource/api/apiUser.js'
import { setStore, getStore, removeStore } from '@/publicResource/utils/utils.js'

Vue.use(Router)
let routeslist = []
const redirectopt = {
  path: '*',
  redirect: '/'
}

function getredicturl(loginInfo) {
  let menulist = []
  if (loginInfo) {
    for (let i = 0, l = loginInfo.userMenuInfo.length; i < l; i++) {
      let obj = {
        parent: '',
        child: []
      }
      if (loginInfo.userMenuInfo[i].parentId === 0) {
        obj.parent = loginInfo.userMenuInfo[i]
        menulist.push(obj)
        // this.rolecheck.push([]);
      }
    }
    for (let i = 0, l = loginInfo.userMenuInfo.length; i < l; i++) {
      for (let j = 0, jl = menulist.length; j < jl; j++) {
        if (loginInfo.userMenuInfo[i].parentId === menulist[j].parent.id) {
          menulist[j].child.push(loginInfo.userMenuInfo[i])
        }
      }
    }
  }
  return menulist[0].child[0].menuUrl
}

// 模块路由添到路由列表
routeslist.push(
  mediator,
  judges,
  disputeMediation,
  onlineMediation,
  organcenter,
  useraction,
  userCenter,
  greffier,
  admin,
  counselor,
  customer,
  lawsuit,
  infocenter,
  judicial,
  tempMediation,
  redirectopt,
  select,
  trainingMaterial,
  statAnalysis,
  backstage,
  test,
  auth,
  applets,
  operationlog
)

const router = new Router({
  mode: 'history',
  routes: routeslist,
  scrollBehavior(to, from, savedPosition) {
    // eslint-disable-next-line no-unused-expressions
    document.querySelectorAll('.el-scrollbar__wrap')[0]
      ? (document.querySelectorAll('.el-scrollbar__wrap')[0].scrollTop = 0)
      : ''
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach(async (to, from, next) => {
  if (to.query.token && to.query.params) {
    try {
      const res = await getHnswToken(to.query.token, to.query.params)
      if (res.data.code === 1000) {
        const data = res.data.data
        const { personType, mobilePhone } = data.loginInfo.userInfo
        removeStore('loginInfo')
        removeStore('loginInfouser')
        setStore('authToken', data.authToken)
        setStore('refreshToken', data.refreshToken)
        if (personType === 'STAFF') {
          let redicturl = ''
          setStore('loginInfo', data.loginInfo)
          redicturl = getredicturl(data.loginInfo)
          setStore('redicturl', redicturl)
          window.location.href = redicturl
        } else {
          setStore('loginInfouser', data.loginInfo)
          let tolink = getStore('tolink')
          if (data.loginInfo.userInfo.isRealName) {
            if (tolink) {
              if (tolink.indexOf('/mediation') > -1) {
                // 如果是要跳到纠纷调解页面，
                // 已实名的话，不用调回纠纷调解页面，直接跳到选择角色页面
                // 如果未实名，则调回纠纷调节页面，实名后跳到选择角色页面
                // 判断是否是中国手机号，非中国手机号直接进入选择角色页面，否则进入扫二维码实名认证页面
                if (
                  data.loginInfo.userInfo.isRealName &&
                  !(
                    getStore('locale') == 'zh_CN' ? /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/ : /^\d+$/
                  ).test(mobilePhone)
                ) {
                  let urlSuffix = tolink.substr(tolink.indexOf('?'), tolink.length)
                  window.location.href = `/selectcharacter${urlSuffix}`
                  removeStore('tolink')
                } else {
                  next('/goToApplets')
                }
              } else {
                window.location.href = tolink
                removeStore('tolink')
              }
            } else {
              // 如果是游客模式新建咨询，进入和咨询师聊天页面，在聊天页面点击登录，登录后在首页
              let isFromChatOnline = document.referrer.indexOf('consultation/chatOnline') !== -1
              if (isFromChatOnline) {
                window.location.href = '/home.html'
              } else {
                window.location.href = '/userCenter/center'
              }
            }
          } else {
            if (
              !(
                getStore('locale') == 'zh_CN'
                  ? /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/
                  : /^\d+$/
              ).test(mobilePhone)
            ) {
              window.location.href = '/userCenter/center'
            } else {
              // return
              var aLink = document.createElement('a')
              aLink.setAttribute('href', '/goToApplets')
              aLink.click()
            }
          }
        }
      } else {
        Vue.prototype.$message({
          showClose: true,
          message: res.data.message || '单点登录失败',
          type: 'error'
        })
      }
    } catch (error) {
      Vue.prototype.$message({
        showClose: true,
        message: '单点登录接口异常',
        type: 'error'
      })
      next('/useraction/login')
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/publicResource/router/index.js